const HookedMarkerIndex = () => import(/* webpackChunkName: "tools" */ '@/pages/tools/hookedMaker');

export default function (router) {
    // 路由配置
    router.addRoutes([
        {
            path: '/tools/hooked/maker',
            component: HookedMarkerIndex,
            meta: {
                title: '浩克春秋编辑器',
                dialog: false
            }
        },
    ]);
}